import ImageGeneric from "@/assets/images/lg.png";
import { ModalBase } from "@/components/ModalBase/ModalBase";
import type { ChatCall } from "@/types/chatCall";
import { Phone, PhoneOff } from "lucide-react";

interface IncomingCallOverlayProps {
  open: boolean;
  call: ChatCall | null;
  isBusy?: boolean;
  ringtoneBlocked?: boolean;
  onAnswer: () => void;
  onReject: () => void;
}

export function IncomingCallOverlay({
  open,
  call,
  isBusy = false,
  ringtoneBlocked = false,
  onAnswer,
  onReject,
}: IncomingCallOverlayProps) {
  const participant = call?.remoteParticipant;

  return (
    <ModalBase
      open={open}
      onOpenChange={() => undefined}
      title="Chamada recebida"
      closeOnOverlayClick={false}
      closeOnEsc={false}
      size="sm"
    >
      <div className="rounded-[30px] bg-white p-6 shadow-2xl">
        <div className="flex flex-col items-center text-center">
          <div className="relative">
            <div className="absolute inset-0 rounded-full bg-[#153ECE]/10 animate-ping" />
            <img
              src={participant?.avatarUrl || ImageGeneric}
              alt={participant?.name || "Usuário"}
              className="relative h-24 w-24 rounded-full object-cover"
            />
          </div>

          <div className="mt-5 space-y-1">
            <p className="text-sm font-medium text-azul-400">
              Chamada de voz recebida
            </p>
            <h2 className="text-2xl font-semibold text-gray-900">
              {participant?.name} {participant?.lastName}
            </h2>
            <p className="text-sm text-gray-500">
              Está ligando para você agora.
            </p>
            {ringtoneBlocked && (
              <p className="text-xs text-amber-600">
                O navegador bloqueou o toque automático. A chamada continua
                visível aqui.
              </p>
            )}
          </div>

          <div className="mt-8 flex w-full gap-3">
            <button
              type="button"
              onClick={onReject}
              disabled={isBusy}
              className="flex flex-1 items-center justify-center gap-2 rounded-full bg-red-500 px-4 py-3 text-sm font-semibold text-white transition-colors hover:bg-red-600 disabled:cursor-not-allowed disabled:opacity-60"
            >
              <PhoneOff size={18} />
              Recusar
            </button>
            <button
              type="button"
              onClick={onAnswer}
              disabled={isBusy}
              className="flex flex-1 items-center justify-center gap-2 rounded-full bg-[#153ECE] px-4 py-3 text-sm font-semibold text-white transition-colors hover:bg-azul-500 disabled:cursor-not-allowed disabled:opacity-60"
            >
              <Phone size={18} />
              Atender
            </button>
          </div>
        </div>
      </div>
    </ModalBase>
  );
}
